var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 730 486",
    width: 730,
    height: 486,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "__element_2998",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "__element_3002"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    d: "M0,0 L730,0 L730,486 L0,486z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "__element_3006",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_3005",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_3006)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.300000190734863,0,0,5.300000190734863,576.2119750976562,446.9210205078125)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,60,0)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  }))))), /*#__PURE__*/React.createElement("filter", {
    id: "__element_3014",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "__element_3033",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "SourceGraphic"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "table",
    tableValues: "1.0 0.0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_3032",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__element_3033)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 730,
    height: 486,
    x: 0,
    y: 0,
    fill: "#ffffff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.5,32.5)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 -315,210 -315,210 C-315,210 -315,-210 -315,-210 C-315,-210 315,-210 315,-210 C315,-210 315,210 315,210z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "__element_3039",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.75,32.75)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,315.25,210.25)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    fillOpacity: 1,
    d: " M315,210 C315,210 83.802001953125,148.13999938964844 14.526000022888184,153.44500732421875 C-54.75,158.75 -315,210 -315,210 C-315,210 -315,-43.5620002746582 -315,-43.5620002746582 C-315,-43.5620002746582 -60.64799880981445,155.5070037841797 13.800999641418457,149.5659942626953 C88.25,143.625 315,59.917999267578125 315,59.917999267578125 C315,59.917999267578125 315,210 315,210z"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_2993)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_2997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,594.4869995117188,465.1960144042969)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,4.25,4.25)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    fill: "rgb(255,60,0)",
    fillOpacity: 1,
    d: " M0,4 C2.2090001106262207,4 4,2.2090001106262207 4,0 C4,-2.2090001106262207 2.2090001106262207,-4 0,-4 C-2.2090001106262207,-4 -4,-2.2090001106262207 -4,0 C-4,2.2090001106262207 -2.2090001106262207,4 0,4z"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_3005)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_3002)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_3032)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46.6099853515625,1)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,399.7569885253906,247.54600524902344)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    fillOpacity: 0,
    stroke: "rgb(255,60,0)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M245.47999572753906,220.89999389648438 C169.04400634765625,244.54600524902344 59.426998138427734,242.91400146484375 30.7450008392334,175.4040069580078 C-21.35300064086914,52.7760009765625 350.74798583984375,-72.48300170898438 371.37200927734375,0.23600000143051147 C396.7569885253906,89.74099731445312 91.2959976196289,138.26600646972656 91.2959976196289,138.26600646972656 C-214.7729949951172,181.89599609375 -311.0050048828125,106.45800018310547 -337.8139953613281,54.5 C-396.7569885253906,-59.733001708984375 -186.88600158691406,-244.54600524902344 -186.88600158691406,-244.54600524902344 C-186.88600158691406,-244.54600524902344 -266.239990234375,-182.9770050048828 -344.14599609375,-182.9770050048828"
  })))))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_3013)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__element_3010)",
    transform: "matrix(1,0,0,1,0,0)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#__element_3039)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-46.6099853515625,1)",
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(1,0,0,1,399.7569885253906,247.54600524902344)"
  }, /*#__PURE__*/React.createElement("path", {
    pathLength: 1,
    className: "animatedPath",
    strokeLinecap: "butt",
    strokeLinejoin: "bevel",
    fillOpacity: 0,
    stroke: "rgb(255, 60, 0)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M 358 -10 C 366 -13 146 -35 36 -10 C -22 21 350.748 -72.483 371.372 0.236 C 396.757 89.741 91.296 138.266 91.296 138.266 C -214.773 181.896 -311.005 106.458 -337.814 54.5 C -396.757 -59.733 -186.886 -244.546 -186.886 -244.546 C -186.886 -244.546 -266.24 -182.977 -344.146 -182.977"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.e53de31936df790ee8884342f8543d28.svg";
export { ForwardRef as ReactComponent };